import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sourceKey: '1',
  distributionKey: '2',
};

const keySelector = createSlice({
  name: 'keySelector',
  initialState,
  reducers: {
    setSourceKey: (state, action) => {
      state.sourceKey = action.payload;
    },
    setDistributionKey: (state, action) => {
      state.distributionKey = action.payload;
    },
  },
});

export const { setSourceKey, setDistributionKey } = keySelector.actions;
export default keySelector.reducer;
